import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SkinDetailPage from './pages/SkinDetailPage';
import RankingSystemPage from './pages/RankingSystemPage';
import TermsPage from './pages/TermsPage';
import AdminPage from './pages/AdminPage';
import AdminLogin from './pages/AdminLogin';
import HltvAdminPage from './pages/HltvAdminPage';
import MatchResultsAdminPage from './pages/MatchResultsAdminPage';
import AdminCrawlerPage from './pages/AdminCrawlerPage';
import AdminSkinsPage from './pages/AdminSkinsPage';
import { AdminProvider } from './contexts/AdminContext';

function App() {
  return (
    <AdminProvider>
      <Router>
        <div className="min-h-screen bg-gray-900">
          <Navbar />
          <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/skin/:id" element={<SkinDetailPage />} />
              <Route path="/ranking-system" element={<RankingSystemPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/admin/hltv" element={<HltvAdminPage />} />
                  <Route path="/admin/matches" element={<MatchResultsAdminPage />} />
                  <Route path="/admin/crawler" element={<AdminCrawlerPage />} />
                  <Route path="/admin/skins" element={<AdminSkinsPage />} />
            </Routes>
          </main>
          
          <Footer />
          
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#1f2937',
                color: '#f9fafb',
                border: '1px solid #374151'
              }
            }}
          />
        </div>
      </Router>
    </AdminProvider>
  );
}

export default App;
